import { SingletonEnginnering } from "../../../flowchart/nodes/_service/singletonEngineering";
import MathEngine from "../../../flowchart/utils/MathEngine";
import { NumberFormat, ParseToNumber } from "../../../flowchart/utils/tools";
import LossStructure from "./LossStructure";
import Mapping from "./Mapping";

class LossConfiguration extends Mapping {
  constructor(mapParent = new Mapping()) {
    super(mapParent);
    
    this.variable = mapParent.id != -9999 ? mapParent.variable : "";
    this.name = mapParent.variable && mapParent.id != -9999 ? "Perda no " + mapParent.variable : "";
    this.lastVariable = mapParent.variable + " geral";
    this.lastValue = mapParent.value;
    this.childrens = [];

    this.AddChildren = function(inputs = [], pair = Mapping) {
      inputs.forEach(i => {
        i.setValue();
        i.value = ParseToNumber(i.value);
      });
      pair.setValue();
      this.childrens.push(new LossStructure(inputs, pair));
    };

    this.setValue = function() {
      if(SingletonEnginnering.isLoaded){
        let result = MathEngine.sentence(this.mapping)
        this.lastValue = NumberFormat(result.value)
        this.childrens.forEach(c => c.setValue())
        return this.lastValue
      }
      else{
        let that = this
        setTimeout(that.setValue, 1000)
      }
    }

    this.getInputsMappings = function() {
      let mapInput = []
      this.childrens.forEach(c => {
        c.mi.forEach(mi => mapInput.push(mi))
      })
      return mapInput
    }

    this.removeInputMapping = function (mapping = Mapping){
      this.childrens.forEach(l => l.removeInputMapping(mapping))
    }
  }
}

export default LossConfiguration;
